/* ------------------------------------------------------------------
   ChampKoi live-fish vocabulary, for the scripts that write their own copy.

   The Liquid side of this lives in snippets/is-live-fish.liquid and
   snippets/fish-noun.liquid; keep the three in step. Everything here answers
   from a product type string, which the cart rows, PDP forms and card grids
   already carry in a data attribute.

   Why: a Tamasaba is not a koi, so a toast reading "This koi is no longer
   available" is wrong on a Tamasaba line. And a bare `type.includes('Koi')`
   test silently drops Single_Tamasaba out of live-fish handling altogether.
   ------------------------------------------------------------------ */
(() => {
  const MIXED = 'fish';

  const isFish = (type) => {
    const t = String(type || '');
    return t.includes('Koi') || t.includes('Tamasaba') || t === 'Dealer Select';
  };

  const isTamasaba = (type) => String(type || '').includes('Tamasaba');

  // Koi is the default: what every caller meant before Tamasaba existed, and
  // the safe answer for an element whose type attribute never got rendered.
  const nounFor = (types) => {
    const list = (Array.isArray(types) ? types : [types]).filter(isFish);
    const tama = list.some(isTamasaba);
    if (!tama) return 'koi';
    return list.some((t) => !isTamasaba(t)) ? MIXED : 'Tamasaba';
  };

  window.CKFish = {
    isFish,
    isTamasaba,

    /**
     * The word for these fish: "koi", "Tamasaba", or "fish" when a list holds
     * both. Both nouns are invariant in the plural, so there is no plural form.
     *
     * @param {string|string[]} types - one product type, or a list of them
     * @returns {string}
     */
    noun: nounFor,

    /** Same word, capitalized for a sentence start. */
    Noun(types) {
      const word = nounFor(types);
      return word === 'Tamasaba' ? word : word.charAt(0).toUpperCase() + word.slice(1);
    },

    /**
     * The noun for an element that carries its own product type, walking up to
     * the nearest ancestor that does. Falls back to "koi" when nothing does.
     *
     * @param {Element|null} el
     * @returns {string}
     */
    nounForEl(el) {
      const host = el && el.closest ? el.closest('[data-product-type]') : null;
      return nounFor(host ? host.dataset.productType : '');
    },
  };
})();
